export class DefaultListButtonOptions {
    constructor(){
    }

    Visible: boolean = true;
    Enabled: boolean = true;

    Load(data: any){
        if(data){
            this.Visible = data.visible != null ? data.visible : true;
            this.Enabled = data.enabled != null ? data.enabled : true;
        }
        return this;
    }
}